import "./style.css";
import moment from "moment";
import { preaddStyles } from "./styles";
import { Dialog } from "@material-ui/core";
import { AddUserForm } from "./addUserForm";
import { FormButton } from "../form/button";
import { useTranslation } from "react-i18next";
import { PreDialogHeader } from "./preDialogHeader";
import { setAlert } from "../../redux/reducers/alert";
import { createUser, editUser } from "../../api/users";
import { useDispatch, useSelector } from "react-redux";
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../theme";
import React, { useReducer, useState, useEffect } from "react";
import {
  validateAddUserForm,
  validateEditUserForm,
  validateNumber,
} from "../../util/validation";

export const AddUserDialog = ({
  open,
  handleClose,
  title,
  successCallback,
  isEditedItem,
  user,
  schoolData,
  editCallback,
}) => {
  const classes = preaddStyles();
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const [
    {
      firstName,
      lastName,
      phone,
      countryCode,
      role,
      schoolId,
      password,
      email,
      emirateId,
      passport,
      birth,
      gender,
      nationality,
      area,
      region,
      address,
      otherPhone,
      employeId,
      designation,
      file,
    },
    setData,
  ] = useReducer((state, newState) => ({ ...state, ...newState }), {
    firstName: "",
    lastName: "",
    role: "",
    schoolId: "",
    phone: "",
    countryCode: "",
    password: "",
    email: "",
    emirateId: "",
    passport: "",
    birth: "",
    gender: "",
    nationality: "",
    area: "",
    region: "",
    address: "",
    otherPhone: "",
    employeId: "",
    designation: "",
    file: "",
  });

  let date = new Date();
  date = moment(date).format("YYYY-MM-DD");
  const [errors, setErrors] = useState([]);

  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const SCHOOL_IDS = [];
  if (user?.role === "superadmin") {
    for (let i = 0; i < schoolData?.length; i++) {
      SCHOOL_IDS.push({ value: schoolData[i]?.id, label: schoolData[i]?.name });
    }
  } else {
    if (user.schoolId) {
      const userSchool = schoolData?.find((item) => item.id === user?.schoolId);
      SCHOOL_IDS.push({ value: userSchool.id, label: userSchool?.name });
    }
  }

  const handleFile = (file) => {
    setData({
      file: file,
    });
  };

  const handleChange = (prop) => (event) => {
    setData({
      [prop]: event.target.value,
    });

    if (errors.indexOf(prop) > -1) {
      const updatedErrors = [...errors];
      updatedErrors.splice(errors.indexOf(prop), 1);
      setErrors(updatedErrors);
    }
  };
  const handleChangePhone = (event, country) => {
    let validIt = validateNumber(event);
    if (validIt) {
      setData({
        phone: event,
        countryCode: country.dialCode,
      });
    }
  };

  const handleChangeOtherPhone = (event) => {
    let validIt = validateNumber(event);
    if (validIt) {
      setData({
        otherPhone: event,
      });
    }
  };
  useEffect(() => {
    if (isEditedItem) {
      setData({
        firstName: isEditedItem.firstName,
        lastName: isEditedItem.lastName,
        role: isEditedItem.role,
        phone: isEditedItem.phone,
        otherPhone: isEditedItem.otherPhone,
        countryCode: isEditedItem.countryCode,
        password: isEditedItem.password,
        email: isEditedItem.email,
        emirateId: isEditedItem.emirateId,
        passport: isEditedItem.passport,
        birth: isEditedItem.birth,
        gender: isEditedItem.gender,
        nationality: isEditedItem.nationality,
        area: isEditedItem.area,
        region: isEditedItem.region,
        address: isEditedItem.address,
        employeId: isEditedItem.employeId,
        designation: isEditedItem.designation,
        schoolId: isEditedItem.schoolId,
      });
    }
  }, [isEditedItem]);

  // useEffect(() => {
  //   if (schoolData?.length > 0 && schoolData[0]?.id) {
  //     setData({
  //       schoolId: schoolData[0]?.id
  //     })
  //   }
  // }, [schoolData])

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };
  const validationForAddUser = (value) =>
    validateAddUserForm(
      firstName,
      lastName,
      phone,
      password,
      email,
      birth,
      area,
      gender,
      region,
      designation,
      nationality,
      address,
      role
    );

  const validationForEditUser = (value) =>
    validateEditUserForm(
      firstName,
      lastName,
      phone,
      birth,
      area,
      gender,
      region,
      designation,
      nationality,
      address,
      role
    );

  const addUserHandler = async () => {
    const validationResponse = validationForAddUser(true);

    if (validationResponse.length > 0) {
      setErrors(validationResponse);
      return;
    }
    try {
      const removeNonDigit = phone.replace(/\D/g, "");
      let searchString = countryCode;
      let regex = new RegExp(searchString, "g");
      const customPhone = removeNonDigit.replace(regex, "");
      setLoading(true);
      const formData = new FormData();
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("role", role);
      formData.append("schoolId", user?.role === "superadmin" ? schoolId : user?.schoolId);
      formData.append("phone", customPhone);
      formData.append("countryCode", countryCode);
      formData.append("password", password);
      formData.append("email", email);
      formData.append("emirateId", emirateId);
      formData.append("passport", passport);
      formData.append("birth", birth);
      formData.append("gender", gender);
      formData.append("nationality", nationality);
      formData.append("area", area);
      formData.append("address", address);
      formData.append("otherPhone", otherPhone);
      formData.append("employeId", employeId);
      formData.append("designation", designation);
      formData.append("file", file);
      formData.append("region", region);
      const { status, message, id } = await createUser(formData, token);
      if (status) {
        showSuccessAlert(message);
        successCallback(id);
        local.push({
          message: "User Created Successfully",
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
      } else {
        showErrorAlert(
          message || t("text_error_in_adding_user_please_try_again")
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || t("text_error_in_adding_user_please_try_again")
      );
    }
  };

  const editSchoolHandler = async () => {
    const validationResponse = validationForEditUser(true);

    if (validationResponse.length > 0) {
      setErrors(validationResponse);
      return;
    }
    try {
      setLoading(true);
      const payload = {
        firstName,
        lastName,
        role,
        emirateId,
        passport,
        birth,
        gender,
        nationality,
        area,
        region,
        address,
        otherPhone,
        employeId,
        designation,
      };

      const response = await editUser(payload, isEditedItem.id, token);
      if (response?.status) {
        editCallback("edit");
        showSuccessAlert(response?.message);
        local.push({
          message: "User Updated Successfully",
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        successCallback();
      } else {
        showErrorAlert(
          response?.message || "Error in updating User. Please try again"
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(err.message || "Error in updating User. Please try again");
    }
  };

  const close = () => handleClose();

  return (
    <Dialog
      className={classes.root}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.mainContainer}>
        <PreDialogHeader
          title={title}
          handleClose={handleClose}
          backbut={true}
        />
        <div className={classes.dropContainer}>
          <AddUserForm
            firstName={firstName}
            lastName={lastName}
            role={role}
            schoolId={schoolId}
            phone={phone}
            password={password}
            email={email}
            emirateId={emirateId}
            passport={passport}
            birth={birth}
            gender={gender}
            nationality={nationality}
            area={area}
            region={region}
            address={address}
            otherPhone={otherPhone}
            employeId={employeId}
            designation={designation}
            errors={errors}
            user={user}
            schoolData={schoolData}
            handleChange={handleChange}
            handleChangePhone={handleChangePhone}
            handleChangeOtherPhone={handleChangeOtherPhone}
            SCHOOL_IDS={SCHOOL_IDS}
            isEditedItem={isEditedItem}
            handleFile={handleFile}
          />
        </div>
        <div className={classes.addSchooldialogFooter}>
          <div className={classes.footerButton}>
            <FormButton
              title={t("text_cancel")}
              backgroundColor={ORANGE_TWO}
              borderColor={ORANGE_TWO}
              titleColor={WHITE}
              hoverBackgroundColor={WHITE}
              hoverBorderColor={ORANGE_TWO}
              hoverTitleColor={ORANGE_TWO}
              onClickHandler={close}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              style={{ fontSize: "0.8vw", fontWeight: "700" }}
            />
          </div>
          <div className={classes.footerButton}>
            <FormButton
              loading={loading}
              loadingColor="white"
              title={t("text_continue")}
              onClickHandler={isEditedItem ? editSchoolHandler : addUserHandler}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              backgroundColor={BLUE_EIGHT}
              titleColor={WHITE}
              hoverTitleColor={BLUE_EIGHT}
              hoverBackgroundColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              style={{ fontSize: "0.8vw", fontWeight: "700" }}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
